export const Type_Leave = 4;
export const Type_Vacation = 5;